import { setSlide } from './sliders';
import globals from './globals';

export default () => {
  const thumbnailsSections = document.querySelectorAll('.c-thumbnails');

  [].forEach.call(thumbnailsSections, thumbnailsSection => {
    const thumbnailButtons = thumbnailsSection.querySelectorAll(
      '.c-thumbnails__item',
    );
    const slider = document.querySelector('.c-thumbnails__slider');

    if (slider !== null) {
      [].forEach.call(thumbnailButtons, thumbnailButton => {
        thumbnailButton.addEventListener('click', event => {
          event.preventDefault();

          if (window.innerWidth < globals.mediumBreakpoint) {
            return;
          }

          slider.classList.add('active');
          globals.html.classList.add('is-slider-fullscreen');
          const slideIndex = parseInt(
            thumbnailButton.getAttribute('data-index'),
            10,
          );

          if (!Number.isNaN(slideIndex)) {
            setSlide(slider, slideIndex);
          }
        });
      });
    }
  });
};



// WEBPACK FOOTER //
// ./src/scripts/modules/thumbnails.js